"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.setOpen = exports.get = void 0;
var imports_1 = require("@lib/imports");
var stevieTexts2_sidecar_1 = require("@uiParts/stevieTexts2-sidecar");
var echoFonts_sidecar_1 = require("@echo/echoFonts-sidecar");
var voyageMessageBuyRequest_sidecar_1 = require("@voyage/multi/voyageMessageBuyRequest-sidecar");
var voyageCarryableData_1 = require("@voyage/entities/voyageCarryableData");
var voyageGameStatus_sidecar_1 = require("@voyage/game-status/voyageGameStatus-sidecar");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
var voyagePicker_sidecar_1 = require("@voyage/ui-cursors/voyagePicker-sidecar");
var voyageUiBuyStuff_data_1 = require("@voyage/ui/voyageUiBuyStuff_data");
var voyageUiBuyStuff_data_sidecar_1 = require("@voyage/ui/voyageUiBuyStuff_data-sidecar");
var voyageUiCanvas_sidecar_1 = require("@voyage/ui/voyageUiCanvas-sidecar");
var voyageUiGButtons_sidecar_1 = require("@voyage/ui/voyageUiGButtons-sidecar");
var voyageUiGraphicsUtils_sidecar_1 = require("@voyage/ui/voyageUiGraphicsUtils-sidecar");
var _lastAtStarbase = false;
var _needsRefresh = true;
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
        exports.setOpen(false);
        render();
    }
    return _obj;
}
exports.get = get;
var create = function () {
    var tw = 700;
    var th = 800;
    var canvas = voyageUiCanvas_sidecar_1.voyageUiCanvas.create(tw, th, voyageLayers_sidecar_1.voyageLayers.getLayers().uiMenu);
    canvas.ox = 0;
    canvas.oy = 0;
    var obj = voyageUiCanvas_sidecar_1.voyageUiCanvas.assign(canvas, {});
    return obj;
};
var updateList = function (list) {
    var x = 20;
    var y = 40;
    var obj = get();
    var addButton = function (text, action) {
        var button = voyageUiGButtons_sidecar_1.voyageUiGButtons.create(text, x, y, action);
        button.w = 200;
        obj.buttons.push(button);
        y += 60;
        if (y > obj.targetHeight - 60) {
            x += 200 + 20;
            y = 40;
        }
    };
    obj.buttons = [];
    imports_1.l.forEach(list, function (c) {
        if (c.kind === voyageUiBuyStuff_data_1.EBuyType.default) {
            return;
        }
        addButton(c.type + ' - ' + c.cost, function () {
            var sel = voyagePicker_sidecar_1.voyagePicker.get().selectedCrew;
            if (sel) {
                voyageMessageBuyRequest_sidecar_1.voyageMessageBuyRequest.sendMessageRequest({
                    crewId: sel.id,
                    buyType: c.kind,
                    itemType: c.item || voyageCarryableData_1.EVoyageCarryableType.Null,
                    cost: c.cost,
                });
            }
            exports.setOpen(false);
        });
    });
    y += 60;
    addButton('Cancel', function () {
        exports.setOpen(false);
    });
};
var render = function () {
    var obj = get();
    var g = obj.graphics;
    voyageUiCanvas_sidecar_1.voyageUiCanvas.clear(obj);
    if (!obj.isOpen) {
        return;
    }
    var addText = function (text, x, y) {
        var _text = stevieTexts2_sidecar_1.stevieTexts2.create(echoFonts_sidecar_1.echoFonts.getData().font6, x, y, obj.layer);
        stevieTexts2_sidecar_1.stevieTexts2.setText(_text, text);
        stevieTexts2_sidecar_1.stevieTexts2.setScale(_text, 3);
        obj.texts.push(_text);
        return _text;
    };
    var x = 0;
    var y = 0;
    var w = obj.targetWidth;
    var h = obj.targetHeight;
    voyageUiGraphicsUtils_sidecar_1.voyageUiGraphicsUtils.bevelPanel(g, x, y, w, h);
    addText('Buy Stuff', x + 6, y); // + 25 - 2)
    x = 400;
    y = 60;
    var status = voyageGameStatus_sidecar_1.voyageGameStatus.get();
    addText('Spacebucks: ' + status.money, x, y);
    y += 20;
    if (status.isAtStarbase) {
        addText('Communicating with ' + status.locationName, x, y);
        y += 20;
    }
    else {
        addText('No starbase in range', x, y);
        y += 20;
    }
    voyageUiCanvas_sidecar_1.voyageUiCanvas.render(obj);
};
var setOpen = function (isOpen) {
    var obj = get();
    if (isOpen && !obj.isOpen) {
        _needsRefresh = true;
    }
    voyageUiCanvas_sidecar_1.voyageUiCanvas.setOpen(obj, isOpen);
    exports.update();
};
exports.setOpen = setOpen;
var update = function () {
    var obj = get();
    var status = voyageGameStatus_sidecar_1.voyageGameStatus.get();
    if (_lastAtStarbase !== status.isAtStarbase) {
        _lastAtStarbase = status.isAtStarbase;
        _needsRefresh = true;
    }
    if (obj.isOpen) {
        if (_needsRefresh) {
            if (status.isAtStarbase) {
                updateList(voyageUiBuyStuff_data_sidecar_1.voyageUiBuyStuff_data.dataList); //['crew', 'fire extinguisher', 'wrench', 'torpedo'])
            }
            else {
                updateList([]);
            }
            _needsRefresh = false;
        }
    }
    voyageUiCanvas_sidecar_1.voyageUiCanvas.update(obj);
    render();
};
exports.update = update;
